export const css = {
    oneaction: '_1VWtlgCC',
    ' _key': 'apic-theme/apic/micro/quiz-widgets/pretest-review'
};
export default css;
